/**
 * KAN-826: fields from list imports (company `extra`, client `profile_data`)
 * as display items. Value shape: {name: {value, to_bot}}; a plain value
 * (older imports) is shown as is, without the bot mark.
 */

export interface ExtraFieldItem {
  name: string;
  value: string;
  toBot: boolean;
}

function displayValue(value: unknown): string {
  if (value === null || value === undefined) return '';
  if (Array.isArray(value)) return value.map(displayValue).filter(Boolean).join(', ');
  if (typeof value === 'object') return JSON.stringify(value);
  return String(value);
}

/** Non-empty fields of an `extra` / `profile_data` object, in its order. */
export function toExtraFieldItems(data: Record<string, unknown> | null | undefined): ExtraFieldItem[] {
  return Object.entries(data ?? {})
    .map(([name, raw]) => {
      if (raw && typeof raw === 'object' && !Array.isArray(raw) && 'value' in raw) {
        const entry = raw as { value?: unknown; to_bot?: unknown };
        return { name, value: displayValue(entry.value), toBot: entry.to_bot === true };
      }
      return { name, value: displayValue(raw), toBot: false };
    })
    .filter((item) => item.value !== '');
}
